export function NoReservationsComponent() {
  return (
    <div className="w-full flex justify-center items-center text-center mt-4 px-3">
      <p>Non ci sono prenotazioni in questa fascia oraria</p>
    </div>
  );
}
